import React, { useContext, useState, useEffect } from "react";
import axios_api from "@utils/axios_api";
import {
  Footer,
  HeaderNavi,
  ScrollTop,
  MyPageLeftMenuStudent,
  Pagination,
} from "@components";
import { AuthContext } from "@context/AuthContext";
import { HeaderContext } from "@context/HeaderContext";
import { get } from "@utils/axios_api";
import { useQuery } from '@tanstack/react-query';
import { Link } from "react-router-dom";


const MyCompletionStudent = () => {
  const { auth } = useContext(AuthContext);
  const { subMenu, setSubMenu } = useContext(HeaderContext);
    /* ---------------- 상태 ---------------- */
  const [activeTab, setActiveTab] = useState("관리감독자정기교육");
  const [pageIndex, setPageIndex] = useState(1);
  const itemsPerPage = 10; // 페이지 당 항목 수


  /* ---------------- 탭 ↔ EDU_TYPE 매핑 ---------------- */
  const tabToEduClass = {
    관리감독자정기교육: "A",
    위험성평가담당자교육: "C",
    근로자안전교육: "B",
  };

  /* 수료한 강의 목록 가져오기 */
  const fetchCompletedLectures = async (tab, pageIndex) => {
    const response = await get("/myCompletionStudent", {
      params: {
        eduClass: tab,
        pageIndex,
        recordCountPerPage: itemsPerPage,
      },
    });
    return response;
  };


  /* 탭 변경 핸들러 */
  const handleTabChange = (tabName) => {
    setActiveTab(tabName);
    setPageIndex(1); // 탭이 변경되면 페이지를 1로 초기화
  };

  /* 페이지 변경 핸들러 */
  const handlePageChange = (newPageIndex) => {
    setPageIndex(newPageIndex);
  };

    /* useQuery를 사용하여 데이터 가져오기 */

 /* useQuery를 사용하여 데이터 가져오기 */
  const { data, isLoading, isError } = useQuery({
      queryKey: ['myCompletionStudent',activeTab, pageIndex],
      queryFn: () => fetchCompletedLectures(tabToEduClass[activeTab], pageIndex),
      enabled: !!auth.userId,
      keepPreviousData: true,
  });



  /* 로그인 여부 확인 */
  useEffect(() => {
    // 페이지 로드 시 서브 메뉴 설정
    setSubMenu("수료정보");
  }, [setSubMenu]);

  

/* ==================== 발급 버튼 클릭 ==================== */
  const handleCertificateDownload = async (lecture) => {
    if (lecture.completeYn !== "Y") {
      return alert("미이수 강의는 확인서를 발급할 수 없습니다.");
    }
    try {
      // ① 직접 axios_api 사용, arraybuffer 로 PDF 받기
      const res = await axios_api.get("/issueApiImpl", {
        params: { lectureId: lecture.lectureId },
        responseType: "arraybuffer",
        timeout: 10000,
      });
      // ② Blob 으로 변환
      const pdfBlob = new Blob([res.data], {
        type: "application/pdf",
      });
      // ③ 파일명 파싱
      const disposition = res.headers["content-disposition"] || "";
      const match = disposition.match(/filename\*=UTF-8''(.+)/i);
      const fileName = match
        ? decodeURIComponent(match[1])
        : "수료증.pdf";
      // ④ 다운로드
      const blobUrl = URL.createObjectURL(pdfBlob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(blobUrl);
    } catch (err) {
      // 서버가 JSON 에러를 blob 으로 내려줄 때
      if (err.response?.data instanceof Blob) {
        const text = await err.response.data.text();
        let msg = "확인서 발급 실패";
        try {
          const json = JSON.parse(text);
          msg = json.errorMessage || json.message || msg;
        } catch {}
        return alert(msg);
      }
      alert(err.message || "확인서 발급 실패");
    }
  };



  if (isLoading) {
    return <div>로딩 중...</div>;
  }

  if (isError) {
    return <div>오류가 발생했습니다</div>;
  }

  return (
    <>
      <ScrollTop />
      <main id="main" className="mainpage">
        <div>
          <div className="section main-contact">
            {/* 헤더 네비게이션 */}
            <HeaderNavi selectedCategory={subMenu} />

            <div className="sub-container">
              <div className="sub-layout">
                {/* 왼쪽 메뉴 */}
                <MyPageLeftMenuStudent />

                {/* 본문 컨텐츠 */}
                <div className="sub-contact">
                  <h3 className="border-bt">수료정보</h3>

                  {/* 탭 메뉴 */}
                  <div className="tab">
                    <ul className="tabnav">
                      {[
                        "관리감독자정기교육",
                        "위험성평가담당자교육",
                        "근로자안전교육",
                      ].map((tabName) => (
                        <li key={tabName}>
                          <a
                            href="#!"
                            className={activeTab === tabName ? "active" : ""}
                            onClick={() => handleTabChange(tabName)}
                          >
                            {tabName}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <div className="tabcontent">
                      {/* 각 탭에 따른 콘텐츠 */}
                      <div>
                        {/* 테이블 */}
                        <div className="lineTop_tb01">
                          <table className="lineTop_tb">
                            <colgroup>
                              <col width="50px" />
                              <col width="250px" />
                              <col width="100px" />
                              <col width="100px" />
                              <col />
                              <col />
                              <col />
                              <col />
                              <col />
                            </colgroup>
                            <thead>
                              <tr>
                                <th>번호</th>
                                <th>강의명</th>
                                <th>교육유형</th>
                                <th>강의날짜</th>
                                <th>강의상태</th>
                                <th>출석여부</th>
                                <th>이수여부</th>
                                <th>이수시간</th>
                                <th>확인서 발급</th>
                              </tr>
                            </thead>
                            <tbody>
                              {data &&
                              data.resultList &&
                              data.resultList.length > 0 ? (
                                data.resultList.map((lecture, index) => (
                                  <tr key={lecture.lectureId}>
                                    <td>{index + 1 + (pageIndex - 1) * itemsPerPage}</td>
                                    <td>
                                      <Link
                                        to={`/myLectures/myStudentLectures/${lecture.lectureId}`}
                                        state={{ subMenu: "수료정보" }}
                                      >
                                        {lecture.lectureNm}
                                      </Link>
                                    </td>
                                    <td>{lecture.eduTypeNm}</td>          {/* ★ */}
                                    <td>{lecture.lectureDate}</td>        {/* ★ */}
                                    <td>{lecture.lectureStatusNm}</td>    {/* ★ */}
                                    <td>{lecture.attendanceYn === "Y" ? "출석" : "결석"}</td> {/* ★ */}
                                    <td>{lecture.completeYn === "Y" ? "이수" : "미이수"}</td> {/* ★ */}
                                    <td>{lecture.completeTime ?? "-"}</td>                   {/* ★ */}
                                    <td>
                                        <button
                                          className="btn btn-green"
                                          disabled={lecture.completeYn !== "Y"}
                                          onClick={() => handleCertificateDownload(lecture)}
                                        >
                                          발급
                                        </button>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="9">이수한 강의가 없습니다.</td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                        {/* 테이블 끝 */}
                      </div>
                      {/* Pagination 추가 */}
                      {data?.paginationInfo &&
                        data.paginationInfo.totalRecordCount > 0 && (
                          <Pagination
                            totalPages={Math.ceil(
                              data.paginationInfo.totalRecordCount /
                                data.paginationInfo.recordCountPerPage
                            )}
                            currentPage={pageIndex}
                            onPageChange={handlePageChange}
                            pageRangeDisplayed={10}
                          />
                        )}
                    </div>
                  </div>
                  {/* 탭 메뉴 끝 */}
                </div>
                {/* 본문 컨텐츠 끝 */}
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </main>
    </>
  );
};

export default MyCompletionStudent;
